import React, { useState, useEffect, SyntheticEvent, useRef } from 'react'
import Link from 'next/link'
import NewCarCard from './new-car-card'
import getLinkHref from 'lib/get-link-href'
import getUrl from 'lib/url'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import fetch from 'lib/decorated-fetch'
const more_ic_b_img = require('../public/static/more-ic-b.png')
const more_ic_b_img2 = require('../public/static/more-ic-b@2x.png')
const more_ic_b_img3 = require('../public/static/more-ic-b@3x.png')

interface ListedItem {
  series_id: number
  series_name: string
  price: string
  online_date: string
  cover_url: string
  series_type: string
}

export default function NewRelease() {
  const [carData, setCarData] = useState([])
  const [tagNow, setTagNow] = useState('listed')
  const containerRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    let tag = 'already'
    tagNow === 'listed' ? (tag = 'already_online') : (tag = 'ready_online')
    fetch(getUrl(`/motor/m_api/new_cars?car_type=${tag}`))
      .then(json => {
        setCarData(json.data)
      })
      .catch(error => {
        console.error(error)
      })
  }, [tagNow])
  const onClickTag = (e: SyntheticEvent) => {
    const target = e.target as HTMLElement
    setTagNow(target.dataset.type || 'listed')
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: 0,
      })
    }
  }
  return (
    <div className="new-release">
      <div className="header-line">
        <span className="title">新车发布</span>
        <Link href="/leaderboard/newcar" as={getLinkHref('/newcar')}>
          <a target="_blank">
            <span
              className="find-more"
              onClick={() => {
                sendTeaCommEvent('click_new_car_list_more')
              }}
            >
              更多
              <img
                src={more_ic_b_img}
                srcSet={`${more_ic_b_img2}, ${more_ic_b_img3}`}
              />
            </span>
          </a>
        </Link>
      </div>
      <div className="tag-line">
        <span
          className={`listed ${tagNow === 'listed' ? 'active' : ''}`}
          data-type="listed"
          onClick={onClickTag}
        >
          已上市
        </span>
        <span
          className={`incoming ${tagNow === 'incoming' ? 'active' : ''}`}
          data-type="incoming"
          onClick={onClickTag}
        >
          即将上市
        </span>
      </div>
      <div className="content-container" ref={containerRef}>
        {carData.map((e: ListedItem, index: number) => (
          <NewCarCard
            {...e}
            key={e.series_id}
            onClick={() => {
              sendTeaCommEvent('click_new_car_list', {
                tab_name: tagNow === 'listed' ? '已上市' : '即将上市',
                rank: index,
                car_series_name: e.series_name,
              })
            }}
          />
        ))}
      </div>
      <style jsx>
        {`
          .new-release {
            width: 100%;
            margin-bottom: 20px;
          }
          .header-line {
            height: 36px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            color: #1f2129;
            align-items: center;
          }
          .title {
            font-size: 24px;
            font-weight: 500;
            line-height: 1.5;
          }
          .find-more {
            font-size: 16px;
            cursor: pointer;
          }
          .find-more img {
            display: inline-block;
            width: 12px;
            height: 12px;
            object-fit: contain;
            margin-left: 2px;
          }
          .tag-line {
            width: 100%;
            height: 32px;
            margin-top: 16px;
          }
          .listed,
          .incoming {
            display: inline-block;
            width: 50%;
            height: 100%;
            line-height: 30px;
            border-radius: 2px;
            text-align: center;
            font-size: 14px;
            font-weight: 500;
            border: solid 1px #1f2129;
            color: #1f2129;
            background-color: white;
            cursor: pointer;
          }
          .listed {
            border-radius: 2px 0 0 2px;
          }
          .incoming {
            border-radius: 0 2px 2px 0;
          }
          .active {
            color: white;
            background-color: #1f2129;
          }
          /*.scroll-hidden-wrapper {
            width: 380px;
            overflow: hidden;
          }*/
          .content-container {
            display: block;
            height: 656px;
            width: 380px;
            margin-top: 24px;
            max-height: 656px;
            overflow-y: scroll;
            overflow-x: hidden;
          }
        `}
      </style>
    </div>
  )
}
